<div class="modal-body" id="modal-body">
  <ng-container *ngIf="contentType === 'detail'; else listBlock">
    <app-companies-detail [pk]="pk" [mode]="mode" [defaults]="defaults"
                          (detailSaved)="modal.close($event)"
                          (detailCancelled)="modal.dismiss()">
    </app-companies-detail>
  </ng-container>
  <ng-template #listBlock>
    <app-companies-list (rowClick)="modal.close($event)" [disableUrlUpdate]="true"
                        [disabledButtons]="localDisabledButtons" [disabledColumns]="disabledColumns"
                        [filters]="filters" [disableRouterLink]="true">
    </app-companies-list>
  </ng-template>
</div>